import { render, staticRenderFns } from "./Varieties.vue?vue&type=template&id=4d5a9c4a&scoped=true&lang=html&"
import script from "./Varieties.vue?vue&type=script&lang=js&"
export * from "./Varieties.vue?vue&type=script&lang=js&"
import style0 from "./Varieties.vue?vue&type=style&index=0&id=4d5a9c4a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5a9c4a",
  null
  
)

export default component.exports